<div class="pointer-events-auto grid size-full place-content-center gap-2">
  @for (mission of missions(); track $index) {
    <rid-button [disabled]="isFinished(mission)" (click)="$lpApiService.startMission(mission, true)">{{ mission.name }}</rid-button>
  }
</div>
